import { STORAGE_KEY } from 'acr_ui/sources/components/constants';
import { acrDatasourcesReducer } from 'acr_ui/sources/components/reducers';
import { combineReducers } from 'redux';

import { authReducer } from 'src/redux/auth/reducers';
import { componentSignalsReducer } from 'src/redux/componentSignals/reducers';
import { viewData } from 'src/redux/data/reducers';
import { routesConfigReducer } from 'src/redux/routesConfig/reducers';
import { viewState } from 'src/redux/view/reducers';

const ACRApp = combineReducers({
  routesConfig: routesConfigReducer,
  auth: authReducer,
  viewData,
  viewState,
  componentSignals: componentSignalsReducer,
  [STORAGE_KEY]: acrDatasourcesReducer,
});

export default ACRApp;
